var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"breadcrumb-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"breadcrumb-content"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Home")])],1),_vm._m(0),_c('li',[_vm._v(_vm._s(_vm.pageName))])])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',{staticStyle:{"padding":"0"}},[_c('i',{staticClass:"el-icon-arrow-right"})])
}]

export { render, staticRenderFns }